import * as _ from "lodash"
import { IwbMetric } from "../PA.Core/PAdbSchemaRowsIF"
import { IMetrics } from "../PA.Metric.Services/PA.Metrics.IF"
import { SimpleRecord } from "../PA.Core/Basic/SimpleRecord"


export class MetricRowUtils {

    static applyVolume(aMetricRow: IwbMetric, volMetrics: IMetrics) {

        aMetricRow.CNSMP_BASE_UNITS = volMetrics.CNSMP_BASE_UNITS || 0
        aMetricRow.CNSMP_BASE_WT = volMetrics.CNSMP_BASE_WT || 0
        aMetricRow.CNSMP_BASE_STAT = volMetrics.CNSMP_BASE_STAT || 0
        aMetricRow.CNSMP_BASE_LISTSLS = volMetrics.CNSMP_BASE_LISTSLS || 0
        aMetricRow.CNSMP_BASE_NETLISTSLS = volMetrics.CNSMP_BASE_NETLISTSLS || 0
        aMetricRow.CNSMP_BASE_RTLSLS = volMetrics.CNSMP_BASE_RTLSLS || 0
        aMetricRow.CNSMP_BASE_PRFTCNTRB = volMetrics.CNSMP_BASE_PRFTCNTRB || 0

        aMetricRow.CNSMP_EDLP_UNITS = volMetrics.CNSMP_EDLP_UNITS || 0
        aMetricRow.CNSMP_EDLP_WT = volMetrics.CNSMP_EDLP_WT || 0
        aMetricRow.CNSMP_EDLP_STAT = volMetrics.CNSMP_EDLP_STAT || 0
        aMetricRow.CNSMP_EDLP_LISTSLS = volMetrics.CNSMP_EDLP_LISTSLS || 0
        aMetricRow.CNSMP_EDLP_NETLISTSLS = volMetrics.CNSMP_EDLP_NETLISTSLS || 0
        aMetricRow.CNSMP_EDLP_RTLSLS = volMetrics.CNSMP_EDLP_RTLSLS || 0
        aMetricRow.CNSMP_EDLP_PRFTCNTRB = volMetrics.CNSMP_EDLP_PRFTCNTRB || 0

        aMetricRow.CNSMP_INCR_UNITS = volMetrics.CNSMP_INCR_UNITS || 0
        aMetricRow.CNSMP_INCR_WT = volMetrics.CNSMP_INCR_WT || 0
        aMetricRow.CNSMP_INCR_STAT = volMetrics.CNSMP_INCR_STAT || 0
        aMetricRow.CNSMP_INCR_LISTSLS = volMetrics.CNSMP_INCR_LISTSLS || 0
        aMetricRow.CNSMP_INCR_NETLISTSLS = volMetrics.CNSMP_INCR_NETLISTSLS || 0
        aMetricRow.CNSMP_INCR_RTLSLS = volMetrics.CNSMP_INCR_RTLSLS || 0
        aMetricRow.CNSMP_INCR_PRFTCNTRB = volMetrics.CNSMP_INCR_PRFTCNTRB || 0

        aMetricRow.CNSMP_DISP_INCR_UNITS = volMetrics.CNSMP_DISP_INCR_UNITS || 0
        aMetricRow.CNSMP_DISP_INCR_WT = volMetrics.CNSMP_DISP_INCR_WT || 0
        aMetricRow.CNSMP_DISP_INCR_STAT = volMetrics.CNSMP_DISP_INCR_STAT || 0
        aMetricRow.CNSMP_DISP_INCR_LISTSLS = volMetrics.CNSMP_DISP_INCR_LISTSLS || 0
        aMetricRow.CNSMP_DISP_INCR_NETLISTSLS = volMetrics.CNSMP_DISP_INCR_NETLISTSLS || 0
        aMetricRow.CNSMP_DISP_INCR_RTLSLS = volMetrics.CNSMP_DISP_INCR_RTLSLS || 0
        aMetricRow.CNSMP_DISP_INCR_PRFTCNTRB = volMetrics.CNSMP_DISP_INCR_PRFTCNTRB || 0

        aMetricRow.CNSMP_TOTAL_UNITS = volMetrics.CNSMP_TOTAL_UNITS || 0
        aMetricRow.CNSMP_TOTAL_WT = volMetrics.CNSMP_TOTAL_WT || 0
        aMetricRow.CNSMP_TOTAL_STAT = volMetrics.CNSMP_TOTAL_STAT || 0
        aMetricRow.CNSMP_TOTAL_LISTSLS = volMetrics.CNSMP_TOTAL_LISTSLS || 0
        aMetricRow.CNSMP_TOTAL_NETLISTSLS = volMetrics.CNSMP_TOTAL_NETLISTSLS || 0
        aMetricRow.CNSMP_TOTAL_RTLSLS = volMetrics.CNSMP_TOTAL_RTLSLS || 0
        aMetricRow.CNSMP_TOTAL_PRFTCNTRB = volMetrics.CNSMP_TOTAL_PRFTCNTRB || 0

        aMetricRow.CNSMP_PROMO_UNITS = volMetrics.CNSMP_PROMO_UNITS || 0
        aMetricRow.CNSMP_PROMO_WT = volMetrics.CNSMP_PROMO_WT || 0
        aMetricRow.CNSMP_PROMO_STAT = volMetrics.CNSMP_PROMO_STAT || 0
        aMetricRow.CNSMP_PROMO_LISTSLS = volMetrics.CNSMP_PROMO_LISTSLS || 0
        aMetricRow.CNSMP_PROMO_NETLISTSLS = volMetrics.CNSMP_PROMO_NETLISTSLS || 0
        aMetricRow.CNSMP_PROMO_RTLSLS = volMetrics.CNSMP_PROMO_RTLSLS || 0
        aMetricRow.CNSMP_PROMO_PRFTCNTRB = volMetrics.CNSMP_PROMO_PRFTCNTRB || 0

        aMetricRow.CNSMP_NONPROMO_UNITS = volMetrics.CNSMP_NONPROMO_UNITS || 0
        aMetricRow.CNSMP_NONPROMO_WT = volMetrics.CNSMP_NONPROMO_WT || 0
        aMetricRow.CNSMP_NONPROMO_STAT = volMetrics.CNSMP_NONPROMO_STAT || 0
        aMetricRow.CNSMP_NONPROMO_LISTSLS = volMetrics.CNSMP_NONPROMO_LISTSLS || 0
        aMetricRow.CNSMP_NONPROMO_NETLISTSLS = volMetrics.CNSMP_NONPROMO_NETLISTSLS || 0
        aMetricRow.CNSMP_NONPROMO_RTLSLS = volMetrics.CNSMP_NONPROMO_RTLSLS || 0
        aMetricRow.CNSMP_NONPROMO_PRFTCNTRB = volMetrics.CNSMP_NONPROMO_PRFTCNTRB || 0

        aMetricRow.MERCH_FEATUREONLY_ACV_N = volMetrics.MERCH_FEATUREONLY_ACV_N || 0
        aMetricRow.MERCH_DISPLAYONLY_ACV_N = volMetrics.MERCH_DISPLAYONLY_ACV_N || 0
        aMetricRow.MERCH_FEATUREDISPLAY_ACV_N = volMetrics.MERCH_FEATUREDISPLAY_ACV_N || 0
        aMetricRow.MERCH_TPRONLY_ACV_N = volMetrics.MERCH_TPRONLY_ACV_N || 0
        aMetricRow.MERCH_PROMOTED_ACV_N = volMetrics.MERCH_PROMOTED_ACV_N || 0
        aMetricRow.MERCH_DIST_ACV_N = volMetrics.MERCH_DIST_ACV_N || 0
        aMetricRow.MERCH_ACV_D = volMetrics.MERCH_ACV_D || 0

        aMetricRow.MERCH_FEATUREONLY_UNITS = volMetrics.MERCH_FEATUREONLY_UNITS || 0
        aMetricRow.MERCH_DISPLAYONLY_UNITS = volMetrics.MERCH_DISPLAYONLY_UNITS || 0
        aMetricRow.MERCH_FEATUREDISPLAY_UNITS = volMetrics.MERCH_FEATUREDISPLAY_UNITS || 0
        aMetricRow.MERCH_TPRONLY_UNITS = volMetrics.MERCH_TPRONLY_UNITS || 0
        aMetricRow.MERCH_PROMOTED_UNITS = volMetrics.MERCH_PROMOTED_UNITS || 0

        aMetricRow.SHIPMENT_ORDER_QTY = volMetrics.SHIPMENT_ORDER_QTY || 0
        aMetricRow.SHIPMENT_BUOM_QTY = volMetrics.SHIPMENT_BUOM_QTY || 0
        aMetricRow.SHIPMENT_UNITS = volMetrics.SHIPMENT_UNITS || 0
        aMetricRow.SHIPMENT_WT = volMetrics.SHIPMENT_WT || 0
        aMetricRow.SHIPMENT_STAT = volMetrics.SHIPMENT_STAT || 0
        aMetricRow.SHIPMENT_LISTSLS = volMetrics.SHIPMENT_LISTSLS || 0
        aMetricRow.SHIPMENT_NETLISTSLS = volMetrics.SHIPMENT_NETLISTSLS || 0
        aMetricRow.SHIPMENT_PRFTCNTRB = volMetrics.SHIPMENT_PRFTCNTRB || 0

        aMetricRow.RETURN_ORDER_QTY = volMetrics.RETURN_ORDER_QTY || 0
        aMetricRow.RETURN_BUOM_QTY = volMetrics.RETURN_BUOM_QTY || 0
        aMetricRow.RETURN_UNITS = volMetrics.RETURN_UNITS || 0
        aMetricRow.RETURN_WT = volMetrics.RETURN_WT || 0
        aMetricRow.RETURN_STAT = volMetrics.RETURN_STAT || 0
        aMetricRow.RETURN_LISTSLS = volMetrics.RETURN_LISTSLS || 0
        aMetricRow.RETURN_NETLISTSLS = volMetrics.RETURN_NETLISTSLS || 0
        aMetricRow.RETURN_PRFTCNTRB = volMetrics.RETURN_PRFTCNTRB || 0

        //
        // Compound Metrics
        aMetricRow.LIST_PRICE = volMetrics.LIST_PRICE || 0
        aMetricRow.LIFT_BYUNITS_PCNT = volMetrics.LIFT_BYUNITS_PCNT || 0
        aMetricRow.LIFT_BYWT_PCNT = volMetrics.LIFT_BYWT_PCNT || 0
        aMetricRow.VCM_CNSMP_INCR_PCNT = volMetrics.VCM_CNSMP_INCR_PCNT || 0
        aMetricRow.VCM_CNSMP_PCNT = volMetrics.VCM_CNSMP_PCNT || 0
        aMetricRow.VCM_SHIP_PCNT = volMetrics.VCM_SHIP_PCNT || 0
        aMetricRow.RETAILER_BASE_PRICE = volMetrics.RETAILER_BASE_PRICE || 0
        aMetricRow.RETAILER_PROMOTED_PRICE = volMetrics.RETAILER_PROMOTED_PRICE || 0
        aMetricRow.RETAILER_AVG_PRICE = volMetrics.RETAILER_AVG_PRICE || 0

        if(_.isFunction(aMetricRow?.notify))
            aMetricRow.notify("All")

    }

    static applyAdjVolume(aMetricRow: IwbMetric, leftAdjMetrics: IMetrics, rightAdjMetrics: IMetrics) {


        aMetricRow.CNSMP_ADJ_INCR_UNITS = 0
        aMetricRow.CNSMP_ADJ_INCR_WT = 0
        aMetricRow.CNSMP_ADJ_INCR_STAT = 0
        aMetricRow.CNSMP_ADJ_INCR_LISTSLS = 0
        aMetricRow.CNSMP_ADJ_INCR_NETLISTSLS = 0
        aMetricRow.CNSMP_ADJ_INCR_RTLSLS = 0
        aMetricRow.CNSMP_ADJ_INCR_PRFTCNTRB = 0

        if (!_.isEmpty(leftAdjMetrics)) {
            aMetricRow.CNSMP_ADJ_INCR_UNITS += leftAdjMetrics.CNSMP_INCR_UNITS
            aMetricRow.CNSMP_ADJ_INCR_WT += leftAdjMetrics.CNSMP_INCR_WT
            aMetricRow.CNSMP_ADJ_INCR_STAT += leftAdjMetrics.CNSMP_INCR_STAT
            aMetricRow.CNSMP_ADJ_INCR_LISTSLS += leftAdjMetrics.CNSMP_INCR_LISTSLS
            aMetricRow.CNSMP_ADJ_INCR_NETLISTSLS += leftAdjMetrics.CNSMP_INCR_NETLISTSLS
            aMetricRow.CNSMP_ADJ_INCR_RTLSLS += leftAdjMetrics.CNSMP_INCR_RTLSLS
            aMetricRow.CNSMP_ADJ_INCR_PRFTCNTRB += leftAdjMetrics.CNSMP_INCR_PRFTCNTRB
        }

        if (!_.isEmpty(rightAdjMetrics)) {
            aMetricRow.CNSMP_ADJ_INCR_UNITS += rightAdjMetrics.CNSMP_INCR_UNITS
            aMetricRow.CNSMP_ADJ_INCR_WT += rightAdjMetrics.CNSMP_INCR_WT
            aMetricRow.CNSMP_ADJ_INCR_STAT += rightAdjMetrics.CNSMP_INCR_STAT
            aMetricRow.CNSMP_ADJ_INCR_LISTSLS += rightAdjMetrics.CNSMP_INCR_LISTSLS
            aMetricRow.CNSMP_ADJ_INCR_NETLISTSLS += rightAdjMetrics.CNSMP_INCR_NETLISTSLS
            aMetricRow.CNSMP_ADJ_INCR_RTLSLS += rightAdjMetrics.CNSMP_INCR_RTLSLS
            aMetricRow.CNSMP_ADJ_INCR_PRFTCNTRB += rightAdjMetrics.CNSMP_INCR_PRFTCNTRB
        }

    }

    static cloneOrCreateEmpty(srcMetricRow: IwbMetric, dflts?: IwbMetric): IwbMetric {
        if(_.isEmpty(srcMetricRow))
            return MetricRowUtils.createEmpty(dflts)

        //
        let rv: IwbMetric = {
            WB_METRIC_ID: 0,
            WB_EVT_ID: srcMetricRow?.WB_EVT_ID || 0,
            WB_PRDGRP_ID: srcMetricRow?.WB_PRDGRP_ID || 0,
            WB_PLAN_ID: srcMetricRow?.WB_PLAN_ID || 0,
            WB_SNAPSHOT_ID: srcMetricRow?.WB_SNAPSHOT_ID || 0,

            REFERENCE_ID: srcMetricRow?.REFERENCE_ID || 0,
            REFERENCE_ID_UI: srcMetricRow?.REFERENCE_ID_UI || '',
            REFERENCE_LEVEL_ID: srcMetricRow?.REFERENCE_LEVEL_ID || '',
            METRIC_TYPE_ID: srcMetricRow?.METRIC_TYPE_ID || '',

            CNSMP_BASE_UNITS: srcMetricRow?.CNSMP_BASE_UNITS || 0,
            CNSMP_BASE_WT: srcMetricRow?.CNSMP_BASE_WT || 0,
            CNSMP_BASE_STAT: srcMetricRow?.CNSMP_BASE_STAT || 0,
            CNSMP_BASE_LISTSLS: srcMetricRow?.CNSMP_BASE_LISTSLS || 0,
            CNSMP_BASE_RTLSLS: srcMetricRow?.CNSMP_BASE_RTLSLS || 0,
            CNSMP_BASE_NETLISTSLS: srcMetricRow?.CNSMP_BASE_NETLISTSLS || 0,
            CNSMP_BASE_PRFTCNTRB: srcMetricRow?.CNSMP_BASE_PRFTCNTRB || 0,

            CNSMP_EDLP_UNITS: srcMetricRow?.CNSMP_EDLP_UNITS || 0,
            CNSMP_EDLP_WT: srcMetricRow?.CNSMP_EDLP_WT || 0,
            CNSMP_EDLP_STAT: srcMetricRow?.CNSMP_EDLP_STAT || 0,
            CNSMP_EDLP_LISTSLS: srcMetricRow?.CNSMP_EDLP_LISTSLS || 0,
            CNSMP_EDLP_RTLSLS: srcMetricRow?.CNSMP_EDLP_RTLSLS || 0,
            CNSMP_EDLP_NETLISTSLS: srcMetricRow?.CNSMP_EDLP_NETLISTSLS || 0,
            CNSMP_EDLP_PRFTCNTRB: srcMetricRow?.CNSMP_EDLP_PRFTCNTRB || 0,

            CNSMP_INCR_UNITS: srcMetricRow?.CNSMP_INCR_UNITS || 0,
            CNSMP_INCR_WT: srcMetricRow?.CNSMP_INCR_WT || 0,
            CNSMP_INCR_STAT: srcMetricRow?.CNSMP_INCR_STAT || 0,
            CNSMP_INCR_LISTSLS: srcMetricRow?.CNSMP_INCR_LISTSLS || 0,
            CNSMP_INCR_RTLSLS: srcMetricRow?.CNSMP_INCR_RTLSLS || 0,
            CNSMP_INCR_NETLISTSLS: srcMetricRow?.CNSMP_INCR_NETLISTSLS || 0,
            CNSMP_INCR_PRFTCNTRB: srcMetricRow?.CNSMP_INCR_PRFTCNTRB || 0,

            CNSMP_DISP_INCR_UNITS: srcMetricRow?.CNSMP_DISP_INCR_UNITS || 0,
            CNSMP_DISP_INCR_WT: srcMetricRow?.CNSMP_DISP_INCR_WT || 0,
            CNSMP_DISP_INCR_STAT: srcMetricRow?.CNSMP_DISP_INCR_STAT || 0,
            CNSMP_DISP_INCR_LISTSLS: srcMetricRow?.CNSMP_DISP_INCR_LISTSLS || 0,
            CNSMP_DISP_INCR_RTLSLS: srcMetricRow?.CNSMP_DISP_INCR_RTLSLS || 0,
            CNSMP_DISP_INCR_NETLISTSLS: srcMetricRow?.CNSMP_DISP_INCR_NETLISTSLS || 0,
            CNSMP_DISP_INCR_PRFTCNTRB: srcMetricRow?.CNSMP_DISP_INCR_PRFTCNTRB || 0,

            CNSMP_TOTAL_UNITS: srcMetricRow?.CNSMP_TOTAL_UNITS || 0,
            CNSMP_TOTAL_WT: srcMetricRow?.CNSMP_TOTAL_WT || 0,
            CNSMP_TOTAL_STAT: srcMetricRow?.CNSMP_TOTAL_STAT || 0,
            CNSMP_TOTAL_LISTSLS: srcMetricRow?.CNSMP_TOTAL_LISTSLS || 0,
            CNSMP_TOTAL_RTLSLS: srcMetricRow?.CNSMP_TOTAL_RTLSLS || 0,
            CNSMP_TOTAL_NETLISTSLS: srcMetricRow?.CNSMP_TOTAL_NETLISTSLS || 0,
            CNSMP_TOTAL_PRFTCNTRB: srcMetricRow?.CNSMP_TOTAL_PRFTCNTRB || 0,

            CNSMP_PROMO_UNITS: srcMetricRow?.CNSMP_PROMO_UNITS || 0,
            CNSMP_PROMO_WT: srcMetricRow?.CNSMP_PROMO_WT || 0,
            CNSMP_PROMO_STAT: srcMetricRow?.CNSMP_PROMO_STAT || 0,
            CNSMP_PROMO_LISTSLS: srcMetricRow?.CNSMP_PROMO_LISTSLS || 0,
            CNSMP_PROMO_RTLSLS: srcMetricRow?.CNSMP_PROMO_RTLSLS || 0,
            CNSMP_PROMO_NETLISTSLS: srcMetricRow?.CNSMP_PROMO_NETLISTSLS || 0,
            CNSMP_PROMO_PRFTCNTRB: srcMetricRow?.CNSMP_PROMO_PRFTCNTRB || 0,

            CNSMP_NONPROMO_UNITS: srcMetricRow?.CNSMP_NONPROMO_UNITS || 0,
            CNSMP_NONPROMO_WT: srcMetricRow?.CNSMP_NONPROMO_WT || 0,
            CNSMP_NONPROMO_STAT: srcMetricRow?.CNSMP_NONPROMO_STAT || 0,
            CNSMP_NONPROMO_LISTSLS: srcMetricRow?.CNSMP_NONPROMO_LISTSLS || 0,
            CNSMP_NONPROMO_RTLSLS: srcMetricRow?.CNSMP_NONPROMO_RTLSLS || 0,
            CNSMP_NONPROMO_NETLISTSLS: srcMetricRow?.CNSMP_NONPROMO_NETLISTSLS || 0,
            CNSMP_NONPROMO_PRFTCNTRB: srcMetricRow?.CNSMP_NONPROMO_PRFTCNTRB || 0,


            CNSMP_ADJ_INCR_UNITS: srcMetricRow?.CNSMP_ADJ_INCR_UNITS || 0,
            CNSMP_ADJ_INCR_WT:  srcMetricRow?.CNSMP_ADJ_INCR_WT || 0,
            CNSMP_ADJ_INCR_STAT:  srcMetricRow?.CNSMP_ADJ_INCR_STAT || 0,
            CNSMP_ADJ_INCR_LISTSLS:  srcMetricRow?.CNSMP_ADJ_INCR_LISTSLS || 0,
            CNSMP_ADJ_INCR_RTLSLS:  srcMetricRow?.CNSMP_ADJ_INCR_RTLSLS || 0,
            CNSMP_ADJ_INCR_NETLISTSLS:  srcMetricRow?.CNSMP_ADJ_INCR_NETLISTSLS || 0,
            CNSMP_ADJ_INCR_PRFTCNTRB:  srcMetricRow?.CNSMP_ADJ_INCR_PRFTCNTRB || 0,

            MERCH_FEATUREONLY_ACV_N: srcMetricRow?.MERCH_FEATUREONLY_ACV_N  || 0,
            MERCH_DISPLAYONLY_ACV_N: srcMetricRow?.MERCH_DISPLAYONLY_ACV_N  || 0,
            MERCH_FEATUREDISPLAY_ACV_N: srcMetricRow?.MERCH_FEATUREDISPLAY_ACV_N  || 0,
            MERCH_TPRONLY_ACV_N: srcMetricRow?.MERCH_TPRONLY_ACV_N  || 0,
            MERCH_PROMOTED_ACV_N: srcMetricRow?.MERCH_PROMOTED_ACV_N  || 0,
            MERCH_DIST_ACV_N: srcMetricRow?.MERCH_DIST_ACV_N  || 0,
            MERCH_ACV_D: srcMetricRow?.MERCH_ACV_D  || 0,
            MERCH_FEATUREONLY_UNITS: srcMetricRow?.MERCH_FEATUREONLY_UNITS  || 0,
            MERCH_DISPLAYONLY_UNITS: srcMetricRow?.MERCH_DISPLAYONLY_UNITS  || 0,
            MERCH_FEATUREDISPLAY_UNITS: srcMetricRow?.MERCH_FEATUREDISPLAY_UNITS  || 0,
            MERCH_TPRONLY_UNITS: srcMetricRow?.MERCH_TPRONLY_UNITS || 0,
            MERCH_PROMOTED_UNITS: srcMetricRow?.MERCH_PROMOTED_UNITS || 0,

            SHIPMENT_ORDER_QTY: srcMetricRow?.SHIPMENT_ORDER_QTY || 0,
            SHIPMENT_BUOM_QTY: srcMetricRow?.SHIPMENT_BUOM_QTY || 0,
            SHIPMENT_UNITS: srcMetricRow?.SHIPMENT_UNITS || 0,
            SHIPMENT_WT: srcMetricRow?.SHIPMENT_WT || 0,
            SHIPMENT_STAT: srcMetricRow?.SHIPMENT_STAT || 0,
            SHIPMENT_LISTSLS: srcMetricRow?.SHIPMENT_LISTSLS || 0,
            SHIPMENT_NETLISTSLS: srcMetricRow?.SHIPMENT_NETLISTSLS || 0,
            SHIPMENT_PRFTCNTRB: srcMetricRow?.SHIPMENT_PRFTCNTRB || 0,

            RETURN_ORDER_QTY: srcMetricRow?.RETURN_ORDER_QTY || 0,
            RETURN_BUOM_QTY: srcMetricRow?.RETURN_BUOM_QTY || 0,
            RETURN_UNITS: srcMetricRow?.RETURN_UNITS || 0,
            RETURN_WT: srcMetricRow?.RETURN_WT || 0,
            RETURN_STAT: srcMetricRow?.RETURN_STAT || 0,
            RETURN_LISTSLS: srcMetricRow?.RETURN_LISTSLS || 0,
            RETURN_NETLISTSLS: srcMetricRow?.RETURN_NETLISTSLS || 0,
            RETURN_PRFTCNTRB: srcMetricRow?.RETURN_PRFTCNTRB || 0,

            SPEND_TOTAL: srcMetricRow?.SPEND_TOTAL || 0,
            SPEND_VARIABLE: srcMetricRow?.SPEND_VARIABLE || 0,
            SPEND_FIXED: srcMetricRow?.SPEND_FIXED || 0,
            SPEND_PA_LE: srcMetricRow?.SPEND_PA_LE || 0,
            SPEND_TRADE: srcMetricRow?.SPEND_TRADE || 0,
            SPEND_VARIABLE_TRADE: srcMetricRow?.SPEND_VARIABLE_TRADE || 0,
            SPEND_FIXED_TRADE: srcMetricRow?.SPEND_FIXED_TRADE || 0,
            SPEND_ALLIN: srcMetricRow?.SPEND_ALLIN || 0,
            SPEND_CONSUMERDISCOUNT: srcMetricRow?.SPEND_CONSUMERDISCOUNT || 0,
            SPEND_SHOPPER_MARKETING: srcMetricRow?.SPEND_SHOPPER_MARKETING || 0,
            SPEND_OTHER_WB: srcMetricRow?.SPEND_OTHER_WB || 0,
            SPEND_RATEBYCNSMP: srcMetricRow?.SPEND_RATEBYCNSMP || 0,
            SPEND_RATEBYSHIPMENT: srcMetricRow?.SPEND_RATEBYSHIPMENT || 0,
            SPEND_LIABILITY_QTY_OVRD: srcMetricRow?.SPEND_LIABILITY_QTY_OVRD || 0,
            SPEND_MARGINAL_OVERLAP: srcMetricRow?.SPEND_MARGINAL_OVERLAP || 0,


            // Compound Metrics
            LIST_PRICE: srcMetricRow?.LIST_PRICE || 0,
            LIFT_BYUNITS_PCNT: srcMetricRow?.LIFT_BYUNITS_PCNT || 0,
            LIFT_BYWT_PCNT: srcMetricRow?.LIFT_BYWT_PCNT || 0,
            VCM_CNSMP_INCR_PCNT: srcMetricRow?.VCM_CNSMP_INCR_PCNT || 0,
            VCM_CNSMP_PCNT: srcMetricRow?.VCM_CNSMP_PCNT || 0,
            VCM_SHIP_PCNT: srcMetricRow?.VCM_SHIP_PCNT || 0,

            TRADETOSALES_CNSMP_PCNT: srcMetricRow?.TRADETOSALES_CNSMP_PCNT || 0,
            TRADETOSALES_SHIP_PCNT: srcMetricRow?.TRADETOSALES_SHIP_PCNT || 0,

            RETAILER_TRUE_BASE_PRICE: srcMetricRow?.RETAILER_TRUE_BASE_PRICE || 0,
            RETAILER_BASE_PRICE: srcMetricRow?.RETAILER_BASE_PRICE || 0,
            RETAILER_PROMOTED_PRICE: srcMetricRow?.RETAILER_PROMOTED_PRICE || 0,
            RETAILER_AVG_PRICE: srcMetricRow?.RETAILER_AVG_PRICE || 0,
            RETAILER_MARGIN_EVERYDAY_PCNT: srcMetricRow?.RETAILER_MARGIN_EVERYDAY_PCNT || 0,
            RETAILER_MARGIN_PROMOTED_PCNT: srcMetricRow?.RETAILER_MARGIN_PROMOTED_PCNT || 0,

            // Standard fields
            CREATED_DTTS: 0,
            MODIFIED_DTTS: 0,
            MODIFIED_DT: '',
            INTEGRATION_IND: '',
            DELETED_IND: '',
            DELETED_DT: ''
        }

        SimpleRecord.eventifyObject(rv)

        return rv
    }

    static createEmpty(mtrcDefaults: IwbMetric): IwbMetric {

        let rv: IwbMetric = {
            WB_METRIC_ID: 0,
            WB_EVT_ID: 0,
            WB_PRDGRP_ID: 0,
            WB_PLAN_ID: 0,
            WB_SNAPSHOT_ID: 0,

            REFERENCE_ID: 0,
            REFERENCE_ID_UI: '',
            REFERENCE_LEVEL_ID: '',
            METRIC_TYPE_ID: '',

            CNSMP_BASE_UNITS: 0,
            CNSMP_BASE_WT: 0,
            CNSMP_BASE_STAT: 0,
            CNSMP_BASE_LISTSLS: 0,
            CNSMP_BASE_RTLSLS: 0,
            CNSMP_BASE_NETLISTSLS: 0,
            CNSMP_BASE_PRFTCNTRB: 0,

            CNSMP_EDLP_UNITS: 0,
            CNSMP_EDLP_WT: 0,
            CNSMP_EDLP_STAT: 0,
            CNSMP_EDLP_LISTSLS: 0,
            CNSMP_EDLP_RTLSLS: 0,
            CNSMP_EDLP_NETLISTSLS: 0,
            CNSMP_EDLP_PRFTCNTRB: 0,

            CNSMP_INCR_UNITS: 0,
            CNSMP_INCR_WT: 0,
            CNSMP_INCR_STAT: 0,
            CNSMP_INCR_LISTSLS: 0,
            CNSMP_INCR_RTLSLS: 0,
            CNSMP_INCR_NETLISTSLS: 0,
            CNSMP_INCR_PRFTCNTRB: 0,

            CNSMP_DISP_INCR_UNITS: 0,
            CNSMP_DISP_INCR_WT: 0,
            CNSMP_DISP_INCR_STAT: 0,
            CNSMP_DISP_INCR_LISTSLS: 0,
            CNSMP_DISP_INCR_RTLSLS: 0,
            CNSMP_DISP_INCR_NETLISTSLS: 0,
            CNSMP_DISP_INCR_PRFTCNTRB: 0,

            CNSMP_TOTAL_UNITS: 0,
            CNSMP_TOTAL_WT: 0,
            CNSMP_TOTAL_STAT: 0,
            CNSMP_TOTAL_LISTSLS: 0,
            CNSMP_TOTAL_RTLSLS: 0,
            CNSMP_TOTAL_NETLISTSLS: 0,
            CNSMP_TOTAL_PRFTCNTRB: 0,

            CNSMP_PROMO_UNITS: 0,
            CNSMP_PROMO_WT: 0,
            CNSMP_PROMO_STAT: 0,
            CNSMP_PROMO_LISTSLS: 0,
            CNSMP_PROMO_RTLSLS: 0,
            CNSMP_PROMO_NETLISTSLS: 0,
            CNSMP_PROMO_PRFTCNTRB: 0,

            CNSMP_NONPROMO_UNITS: 0,
            CNSMP_NONPROMO_WT: 0,
            CNSMP_NONPROMO_STAT: 0,
            CNSMP_NONPROMO_LISTSLS: 0,
            CNSMP_NONPROMO_RTLSLS: 0,
            CNSMP_NONPROMO_NETLISTSLS: 0,
            CNSMP_NONPROMO_PRFTCNTRB: 0,


            CNSMP_ADJ_INCR_UNITS: 0,
            CNSMP_ADJ_INCR_WT: 0,
            CNSMP_ADJ_INCR_STAT: 0,
            CNSMP_ADJ_INCR_LISTSLS: 0,
            CNSMP_ADJ_INCR_RTLSLS: 0,
            CNSMP_ADJ_INCR_NETLISTSLS: 0,
            CNSMP_ADJ_INCR_PRFTCNTRB: 0,

            MERCH_FEATUREONLY_ACV_N: 0,
            MERCH_DISPLAYONLY_ACV_N: 0,
            MERCH_FEATUREDISPLAY_ACV_N: 0,
            MERCH_TPRONLY_ACV_N: 0,
            MERCH_PROMOTED_ACV_N: 0,
            MERCH_DIST_ACV_N: 0,
            MERCH_ACV_D: 0,
            MERCH_FEATUREONLY_UNITS: 0,
            MERCH_DISPLAYONLY_UNITS: 0,
            MERCH_FEATUREDISPLAY_UNITS: 0,
            MERCH_TPRONLY_UNITS: 0,
            MERCH_PROMOTED_UNITS: 0,

            SHIPMENT_ORDER_QTY: 0,
            SHIPMENT_BUOM_QTY: 0,
            SHIPMENT_UNITS: 0,
            SHIPMENT_WT: 0,
            SHIPMENT_STAT: 0,
            SHIPMENT_LISTSLS: 0,
            SHIPMENT_NETLISTSLS: 0,
            SHIPMENT_PRFTCNTRB: 0,

            RETURN_ORDER_QTY: 0,
            RETURN_BUOM_QTY: 0,
            RETURN_UNITS: 0,
            RETURN_WT: 0,
            RETURN_STAT: 0,
            RETURN_LISTSLS: 0,
            RETURN_NETLISTSLS: 0,
            RETURN_PRFTCNTRB: 0,

            SPEND_TOTAL: 0,
            SPEND_VARIABLE: 0,
            SPEND_FIXED: 0,
            SPEND_PA_LE: 0,
            SPEND_TRADE: 0,
            SPEND_VARIABLE_TRADE: 0,
            SPEND_FIXED_TRADE: 0,
            SPEND_ALLIN: 0,
            SPEND_CONSUMERDISCOUNT: 0,
            SPEND_SHOPPER_MARKETING: 0,
            SPEND_OTHER_WB: 0,
            SPEND_RATEBYCNSMP: 0,
            SPEND_RATEBYSHIPMENT: 0,
            SPEND_LIABILITY_QTY_OVRD: 0,
            SPEND_MARGINAL_OVERLAP: 0,

            LIST_PRICE: 0,
            LIFT_BYUNITS_PCNT: 0,
            LIFT_BYWT_PCNT: 0,
            VCM_CNSMP_INCR_PCNT: 0,
            VCM_CNSMP_PCNT: 0,
            VCM_SHIP_PCNT: 0,

            TRADETOSALES_CNSMP_PCNT: 0,
            TRADETOSALES_SHIP_PCNT: 0,

            RETAILER_TRUE_BASE_PRICE: 0,
            RETAILER_BASE_PRICE: 0,
            RETAILER_PROMOTED_PRICE: 0,
            RETAILER_AVG_PRICE: 0,
            RETAILER_MARGIN_EVERYDAY_PCNT: 0,
            RETAILER_MARGIN_PROMOTED_PCNT: 0,

            CREATED_DTTS: 0,
            MODIFIED_DTTS: 0,
            MODIFIED_DT: '',
            INTEGRATION_IND: '',
            DELETED_IND: '',
            DELETED_DT: ''
        }

        _.forEach(mtrcDefaults || {}, (val, key) => {
            rv[key] = val
        })

        SimpleRecord.eventifyObject(rv)

        return rv
    }

    static calcSpendCompoundMetrics(aMetricRow: IwbMetric) {
        aMetricRow.TRADETOSALES_CNSMP_PCNT = (aMetricRow.CNSMP_TOTAL_NETLISTSLS > 0) ? aMetricRow.SPEND_TRADE / aMetricRow.CNSMP_TOTAL_NETLISTSLS : 0
        aMetricRow.TRADETOSALES_SHIP_PCNT = (aMetricRow.SHIPMENT_NETLISTSLS > 0) ? aMetricRow.SPEND_TRADE / aMetricRow.SHIPMENT_NETLISTSLS : 0
        aMetricRow.RETAILER_MARGIN_EVERYDAY_PCNT = (aMetricRow.CNSMP_TOTAL_RTLSLS > 0) ? ((aMetricRow.CNSMP_TOTAL_RTLSLS - aMetricRow.CNSMP_TOTAL_NETLISTSLS + aMetricRow.SPEND_TOTAL) / aMetricRow.CNSMP_TOTAL_RTLSLS) : 0
        aMetricRow.RETAILER_MARGIN_PROMOTED_PCNT = (aMetricRow.CNSMP_PROMO_RTLSLS > 0) ? ((aMetricRow.CNSMP_PROMO_RTLSLS - aMetricRow.CNSMP_PROMO_NETLISTSLS + aMetricRow.SPEND_TOTAL) / aMetricRow.CNSMP_PROMO_RTLSLS) : 0

        if(_.isFunction(aMetricRow?.notify))
            aMetricRow.notify("All")

    }

}